import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { Box, InnerHeading, TextStyled } from '../ui/Elements'
import { useTranslation } from 'react-i18next'
import LangChangeButton from '../Languages/LangChangeButton'


const ErrorPage = () => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	const imgurl = 'https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif';
	return (
		<ErrorPageWrapper>
			<LangChangeButton className="langBtn" />
			<div className="mars"></div>
			<img src="https://assets.codepen.io/1538474/404.svg" className="logo-404" />
			<img src="https://assets.codepen.io/1538474/meteor.svg" className="meteor" />
			<Box>
				<InnerHeading className='mb-3' lh="1.2" size="35px" color="var(--themeColor)">{t('Ohno')}</InnerHeading>
				<TextStyled className="subtitle">
					{t("Youeithermisspelling")} <br /> {t("requestingpage")}
				</TextStyled>
				<button className='btn btn-outline-warning hBtn' onClick={() => navigate("/")} >{t("Home")}</button>
			</Box>
			<img src="https://assets.codepen.io/1538474/astronaut.svg" className="astronaut" />
			<img src="https://assets.codepen.io/1538474/spaceship.svg" className="spaceship" />
		</ErrorPageWrapper>
	)
}

export default ErrorPage

const ErrorPageWrapper = styled.div`
    width: 100%;
    height: 100vh;
    text-align: center;
    background: var(--darkGradient);
    display: flex;
    align-items: center;
    justify-content: center;
    .langBtn{
      visibility: hidden;
      height: 0;
      width: 0;
    }
    .hBtn{
        font-family: var(--semiBold);
      }
    body.rtl &{
      .hBtn{
        font-family: var(--arSemiBold);
      }
    }
    

	$nunito-font: 'Nunito', sans-serif;

	// mixins
	@mixin breakpoint($point) {
		@if $point==mobile {
			@media (max-width: 480px) and (min-width: 320px) {
				@content ;
			}
		}
	}

	// keyrames
	@keyframes floating {
		from { transform: translateY(0px); }
		65%  { transform: translateY(15px); }
		to   { transform: translateY(-0px); }
	}

	html {
	height: 100%;
	}

	body{
	background-image: url('https://assets.codepen.io/1538474/star.svg'),linear-gradient(to bottom, #05007A, #4D007D);
	height: 100%;
	margin: 0;
	background-attachment: fixed;
	overflow: hidden;
	}

	.mars{
	left:0;
	right:0;
	bottom:0;
	position:absolute;
	height: 27vmin;
	background: url('https://assets.codepen.io/1538474/mars.svg') no-repeat top center;
	background-size: cover;
	}

	.logo-404{
	position: absolute;
	margin-left: auto;
	margin-right: auto;
	left: 0;
	right: 0;
	top: 16vmin;
	width: 30vmin;

	@include breakpoint(mobile){
		top: 45vmin;
	}
	}

	.meteor{
	position: absolute;
	right: 2vmin;
	top: 16vmin;
	}

	.title{
	
	font-family: var(--bold);
	text-align: center;
	font-size: 5vmin;
	margin-top: 1vmin;

	@include breakpoint(mobile){
		margin-top: 15vmin;
	}
	}

	.subtitle{
	color: var(--darkGrey) !important;
	-webkit-text-fill-color: var(--darkGrey) !important;
	text-align: center;
	font-family: var(--regular);
	font-size: 3vmin;
	margin-top: -1vmin;
	margin-bottom: 9vmin;
	line-height: 1.8;
	}
	.btn{
	background-color: var(--themeColor);
	border: none;
	color: #ffffff;
	}
	.btn-back{
	border: 1px solid white;
	color: white;
	height: 5vmin;
	padding: 12px;
	
	text-decoration: none;
	border-radius: 5px;

	&:hover{
		background: white;
		color: #4D007D;
	}

	@include breakpoint(mobile){
		font-size: 3.5vmin;
	}
	}

	.astronaut{
		position: absolute;
		top: 18vmin;
		left: 10vmin;
		height: 30vmin;
		animation: floating 3s infinite ease-in-out;
		@media (max-width: 991px) {
				top: 8vmin;
				left: 0vmin;
		}
		@include breakpoint(mobile){
			top: 2vmin;
		}
	}

	.spaceship{
	position: absolute;
	bottom: 15vmin;
	right: 24vmin;

	@include breakpoint(mobile){
		width: 45vmin;
		bottom: 18vmin;
	}
	}


`